<template>
  <div class="menu-group">
    <div class="group-title" :class="isActive('url')" @click="toggleSubMenu">
      <!--      展开时展示内容-->
      <template v-if="sidebarOpened">
        <img v-if="item.icon" :src="item.icon" alt="" />
        <span>{{ item.name }}</span>
        <i v-if="item.list" class="el-icon-arrow-down" :class="{ rotated: isSubMenuOpen }"></i>
        <template v-else-if="item.url">
          <i v-if="!item.isFavorite" class="icon-fav iconfont"></i>
          <i v-else class="icon-favoured iconfont"></i>
        </template>
      </template>
      <!--      收起时展示内容-->
      <template v-else>
        <img v-if="item.icon" style="margin-right: 0px; margin-bottom: 8px" :src="item.icon" alt="" />
        <span style="min-width: 50px; text-align: center; font-size: 12px">{{ item.abbrName }}</span>
      </template>
    </div>
    <transition name="slide-fade">
      <ul v-show="isSubMenuOpen" class="group-children">
        <li
          v-for="itemx in item.list"
          :key="itemx.id"
          class="group-children_list"
          :class="isActive(itemx.url)"
          @click="itemClick(itemx)"
          @mouseenter="getChildren(itemx)"
        >
          <!--          @mouseenter="getChildren(itemx)"-->
          <!--          @click="itemClick(itemx)"-->
          <div>
            <i class="icon" :class="itemx.icon"></i>
            <span>{{ itemx.name }}</span>
          </div>
          <i v-if="itemx.list" class="arrow el-icon-arrow-right"></i>
          <template v-else-if="itemx.url">
            <i v-if="!favoriteMenusIds().includes(itemx.id)" class="icon-fav iconfont" @click.stop="favoriteIt(itemx)"></i>
            <i v-else class="icon-favoured iconfont" @click.stop="cancelFavoriteIt(itemx)"></i>
          </template>
          <!--第二竖排菜单-->
          <div v-if="secondMenu.length > 0 && nowSys === itemx.url" class="second-menu">
            <template v-for="secondeItem in secondMenu">
              <second-index :key="secondeItem.id" :item="secondeItem" :sys-belong="itemx.url" @item-click="itemClick"></second-index>
            </template>
          </div>
        </li>
      </ul>
    </transition>
  </div>
</template>

<script>
import SecondIndex from "@/layout/components/NewSider/SidebarItem/second-index.vue"
import { mapActions, mapState } from "vuex"
import { userCollectMenu, userCollectMenuDel } from "@/api/user"
export default {
  name: "SidebarItem",
  components: { SecondIndex },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    },
    level: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      secondMenu: [],
      isSubMenuOpen: false
    }
  },
  computed: {
    sidebarOpened() {
      return this.$store.state.app.sidebar.opened
    },
    sidebarFakeClick() {
      return this.$store.state.app.sidebar.fakeClick
    },
    ...mapState("user", ["favoriteMenus", "nowSys"])
  },
  watch: {
    sidebarOpened: {
      handler(n) {
        this.isSubMenuOpen = false
        if (n) {
          // 展开时，默认展开选中的菜单
          const listUrlArr = this.item.list.map(item => item.url)
          if (listUrlArr.includes(this.$route.fullPath.split("#")[0])) {
            this.isSubMenuOpen = true
          }
        }
      },
      immediate: true
    }
  },
  created() {
    // 接收通知，清空secondMenu,减轻dom负担
    this.$bus.$on("clearSecondMenu", item => {
      this.secondMenu = []
    })
  },
  beforeDestroy() {
    this.$bus.$off("clearSecondMenu")
  },
  methods: {
    ...mapActions("user", ["getFavorite"]),
    // 返回收藏菜单id集合
    favoriteMenusIds() {
      return this.favoriteMenus.map(item => item.id)
    },
    // 收藏菜单
    favoriteIt(item) {
      userCollectMenu({ menuId: item.id }).then(res => {
        // 重新获取收藏菜单
        this.getFavorite()
      })
    },
    // 取消收藏
    cancelFavoriteIt(item) {
      userCollectMenuDel({ menuId: item.id }).then(res => {
        // 重新获取收藏菜单
        this.getFavorite()
      })
    },
    // 匹配激活
    isActive(url) {
      // 业务域选中状态
      const listUrlArr = this.item.list.map(item => item.url)
      if (!this.sidebarOpened && listUrlArr.includes(this.$route.fullPath.split("#")[0])) {
        return "active"
      }
      // 目录菜单(要判断一下系统管理和权限管理，统一项目，但是目录不是同一个，所以需要单端判断)
      if (this.$route.fullPath.split("#")[0] === url || (this.$route.fullPath.split("#")[0] === "/masterData" && url === "/authorityCenter")) {
        return "active"
      }
      // 可点击菜单
      if (this.$route.fullPath === "/" + url.split("/")[1] + "#" + url) {
        return "active"
      }
      return ""
    },
    toggleSubMenu() {
      // 收起时，禁用上下展开功能
      if (!this.sidebarOpened) {
        // 收起时，点击，展开菜单
        this.$store.dispatch("app/toggleSideBar")
        // 并存储是点击收起的侧边栏的状态
        this.$store.commit("app/SAVE_FAKECLICK")
        setTimeout(() => {
          // 并且展开点击的菜单
          this.isSubMenuOpen = true
        }, 100)
        return
      }
      if (this.item.list) {
        this.isSubMenuOpen = !this.isSubMenuOpen
      } else {
        alert(3333)
      }
    },
    // 获取下一级菜单
    getChildren(item) {
      // 通知其他组件，清空secondMenu数组
      this.$bus.$emit("clearSecondMenu")
      // 重新赋值
      this.secondMenu = item.list || []
      this.$store.commit("user/SET_NOWSYS", item.url)
    },
    // 点击菜单
    itemClick(item) {
      // 有子元素，则不往下走,直接打开子菜单
      if (item.list) {
        // this.getChildren(item)
        return
      }
      item.fullPath = this.resolvePath(item.url)
      item.meta = {
        title: item.name
      }
      this.$router.push({ path: item.fullPath })
      this.$store.dispatch("tagsView/addView", item)
      // 重制nowSys,让二层菜单隐藏
      this.$store.commit("user/SET_NOWSYS", "")
      // 判断是否是收缩时，点击弹起的，如果是，则再次收缩
      if (this.sidebarFakeClick) {
        this.$store.dispatch("app/toggleSideBar")
      }
    },
    resolvePath(routePath) {
      // 帆软报表暂时处理，后期需要统一在数据中心，进行页面前置
      if (routePath === "https://fr.osa.com/webroot/decision/view/report?viewlet=/流程与IT/帆软广告回本报表.cpt") {
        return "/count#/count/fanruan"
      }
      if (routePath === "https://fr.osa.com/webroot/decision/view/form?viewlet=WCT/数据中心/AB客_裂变销售报表.frm") {
        return "/count#/count/fanruanAB"
      }
      // //权限中心比较特殊，没有作为一个中心上传git，而是和主数据合在一起，所以需要单独判断下
      const isAuthorityCenter = routePath.split("/")?.[1] === "authorityCenter"
      if (isAuthorityCenter) {
        console.log(routePath)
        return "/masterData" + "#" + routePath
      } else {
        return "/" + routePath.split("/")[1] + "#" + routePath
      }
    }
  }
}
</script>
<style scoped lang="scss">
.menu-group .group-title {
  background-color: #132547; /* 组标题背景色 */
  padding: 15px 20px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.3s ease; /* 组标题背景色过渡 */
  overflow: hidden;
}

.menu-group .group-title:hover {
  background-color: #1e3052; /* 组标题悬停背景色 */
}

.menu-group .group-title i {
  margin-right: 10px;
}
.menu-group img {
  width: 16px;
  height: 16px;
  margin-right: 10px;
}
.menu-group .group-title span {
  flex: 1;
  flex-shrink: 0;
}

.menu-group .group-title .el-icon-arrow-down {
  transition: transform 0.3s ease; /* 箭头旋转过渡 */
}

.menu-group .group-title .rotated {
  transform: rotate(180deg); /* 旋转箭头 */
}

.menu-group ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.menu-group li {
  padding: 10px 20px;
}

.menu-group a {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #ffffff;
  transition: color 0.3s ease; /* 链接颜色过渡 */
}

.menu-group a:hover {
  color: #dcddde; /* 链接悬停颜色 */
}

.menu-group a i {
  margin-right: 10px;
}

.collapsed .menu-group span,
.collapsed .menu-group .group-title span {
  display: none;
}
.group-children {
  background: #051432;
  li {
    cursor: pointer;
    padding: 15px 30px 15px 40px !important;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  li:hover {
    background: #1e3052;
  }
  li:hover .second-menu {
    display: block;
  }
}
/* 过渡动画 */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.3s ease;
  overflow: hidden; /* 防止展开时内容溢出 */
  max-height: 300px; /* 设置最大高度，防止展开过快 */
}
.slide-fade-enter,
.slide-fade-leave-to {
  max-height: 0;
  opacity: 0;
}
.second-menu {
  position: absolute;
  left: 200px;
  top: 0;
  width: 210px;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  background: #1d325b;
  display: none;

  /* 改造滚动条-适用于google内核 */

  ::-webkit-scrollbar {
    /* 控制竖向滚动条的宽度 */
    width: 3px;
    /* 控制横向滚动条的高度 */
    height: 3px;
    background-color: #fff;
  }
  ::-webkit-scrollbar-thumb {
    /* box-shadow: inset 0 0 6px rgba(0, 0, 0, .3); */
    background-color: rgba(144, 147, 153, 0.3);
    border-radius: 10px;
  }
  ::-webkit-scrollbar-track {
    /* box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2); */
    border-radius: 3px;
    background: rgba(255, 255, 255, 1);
  }
}
.icon-fav,
.icon-favoured {
  font-size: 12px;
  color: #faad14;
}
.active {
  background-color: #3296fa !important;
}
</style>
